import { Outlet, useLocation } from "react-router-dom";
import Navbar from './Navbar';
import Footer from './Footer';
import SubMenu from './SubMenu';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

const Layout = () => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("authToken");
  const shouldShowSubMenu = isAuthenticated && ([
    '/pages/dashboard',
    '/pages/user-profile',
    '/pages/school-profile',
    '/pages/security',
    '/pages/configurator',
    '/pages/admin',
    '/pages/info',
    '/'
  ].includes(location.pathname));

  const dynamicMdSize = shouldShowSubMenu ? 8 : 12; 

  return (
    <>
      {/* Navbar bleibt oben */}
      <nav>
        <Navbar />
      </nav>

      {/* app_wrapper als zentrales Layout für Submenü und Hauptinhalt */}
      <Box className="app_wrapper" sx={{ display: 'flex', margin: '0 auto', width: '100%', maxWidth: '1600px', paddingBottom: '100px' }}>
        <Grid container spacing={2} sx={{ width: '100%'}}>
          <Grid size={{ md: 4 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            {shouldShowSubMenu && (
                <SubMenu />
            )}
          </Grid>
          {/* Main Content */}
          <Grid size={{ md: dynamicMdSize }}>
            <Box>
              <Outlet />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Footer />
    </>
  );
};

export default Layout;
